import { useSignedListingPhoto } from "@/lib/listingPhotos";

interface ListingPhotoProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> {
  value: string | null | undefined;
  fallback?: React.ReactNode;
}

/**
 * Displays a listing photo by resolving the stored value (path or legacy
 * public URL) to a short-lived signed URL from the private bucket.
 */
export function ListingPhoto({
  value,
  fallback,
  alt = "",
  loading = "lazy",
  decoding = "async",
  ...rest
}: ListingPhotoProps) {
  const url = useSignedListingPhoto(value);
  if (!url) return <>{fallback ?? null}</>;
  return <img src={url} alt={alt} loading={loading} decoding={decoding} {...rest} />;
}
